export class Respuesta  {    
    public booOk?: boolean;
    public strValor?: string;
    public strMensaje?: string;
}